import React from "react";
import CountUp from "react-countup";

const platform = window.navigator.platform;
const iosPlatforms = ["iPhone", "iPad", "iPod"];

const formatNegativeNumber = value => {
  return value.toLocaleString("pt-BR", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
};

const CurrencyValue = props => {
  if (props.type === "money") {
    if (iosPlatforms.indexOf(platform) !== -1 || props.value < 0) {
      return `R$ ${formatNegativeNumber(props.value / 100)}`;
    } else {
      return (
        <CountUp
          start={0}
          end={props.value / 100 || 0}
          duration={1.5}
          useEasing
          useGrouping
          separator="."
          decimal=","
          decimals={2}
          prefix="R$ "
        />
      );
    }
  }
  if (props.type === "integer") {
    if (iosPlatforms.indexOf(platform) !== -1 || props.value < 0) {
      return `${props.value / 100}`;
    } else {
      return (
        <CountUp
          start={0}
          end={props.value / 100}
          duration={1.5}
          useEasing
          useGrouping
          separator=" "
          decimal="."
          decimals={0}
        />
      );
    }
  } else {
    if (iosPlatforms.indexOf(platform) !== -1 || props.value < 0) {
      return `${formatNegativeNumber(props.value) || 0}`;
    } else {
      return (
        <CountUp
          start={0}
          end={props.value || 0}
          duration={1.5}
          useEasing
          useGrouping
          separator="."
          decimal=","
          decimals={2}
        />
      );
    }
  }
};

export default CurrencyValue;



// WEBPACK FOOTER //
// ./src/components/support/currency-value/index.jsx